function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.23 3.165l5.605 5.604M14 3L8 9",
  stroke: "currentColor",
  strokeWidth: 3,
  fill: "currentColor",
  fillRule: "evenodd",
  strokeLinecap: "square"
});

function SvgIconChevronDown(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 17 12"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTcgMTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMyIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiPjxwYXRoIGQ9Ik0yLjIzIDMuMTY1bDUuNjA1IDUuNjA0TTE0IDNMOCA5Ii8+PC9nPjwvc3ZnPg==";
export { SvgIconChevronDown as ReactComponent };